module.exports = __webpack_public_path__ + "img/SO.2f7ce7f9.svg";